export const mediaProperty = (
  slideAssetType: string,
  assetFormat: string,
  carouselWidth: number,
) => {
  if (slideAssetType === 'image') {
    if (assetFormat === 'small' || carouselWidth <= 767) {
      return {
        property: 'slideImageAsset',
        label: 'Image (Portrait) - Asset',
      };
    } else {
      return {
        property: 'slideImageLandscapeAsset',
        label: 'Image (Landscape) - Asset',
      };
    }
  }
  if (assetFormat === 'small' || carouselWidth <= 767) {
    return {
      property: 'slideVideoPortraitAsset',
      label: 'Video (Portrait) - Asset',
    };
  } else {
    return {
      property: 'slideVideoLandscapeAsset',
      label: 'Video (Landscape) - Asset',
    };
  }
};
